import React from "react";
import Overview from "../../Components/OrganizationSettings/Overview";
import NoAccessComponent from "../../Components/Shared/Error/NoAccess";

const WorkspaceOrganizationSettingPage = ({ organization, user, role }) => {

    const reload = (url) => {
        window.parent.postMessage(JSON.stringify({ reload: true, organizationUrl: url }), process.env.REACT_APP_RUNTIME_URL);
    }

    const authorized = role.roleType === 'Owner' || role.roleType === 'Administrator';
    if (!authorized) {
        return <NoAccessComponent />
    }
    return (
        <Overview
            showInIframe={true}
            reload={reload}
            organization={organization}
            userRole={role.roleType}
            user={user}
        />
    );
};

export default WorkspaceOrganizationSettingPage; 